import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-side-bar-partner',
  templateUrl: './side-bar-partner.component.html',
  styleUrls: ['./side-bar-partner.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarPartnerComponent implements OnInit {
  user: any | null;
  isCollapsed = true;
  urlClasseVirtuelle: string =
    'https://formation.force-n.sn/mod/bigbluebuttonbn/view.php?id=43470';
  urlFondAmorcage: string = 'https://fa.force-n.sn/auth/login/keycloak';
  showIframe = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  openUrl(url: string): void {
    window.open(url, '_blank');
  }
}
